export const isConfirmationPage = (path) => path.indexOf('/signup-confirmation') !== -1;

export const isGiftingHomePage = (path) => path.includes('/redeem');

export const isGiftingPages = (path) => path.includes('redeem');

export const isSignUpPage = (path) => path.includes('signup-account');

export const isSignUpPlans = (path) => path.includes('signup-plans');

export const isSignInPage = (path) => path.includes('signin');

export const isPaymentPage = (path) => path.includes('payment');
